import { createPlugin } from '@front/utils/alpine';
import Cookies from "js-cookie";

export const keptValues = JSON.parse(Cookies.get('keep') || '{}');

export default createPlugin((vm) => {

    vm.directive('keep', (el, { value, modifiers, expression }, { evaluate }) => {
        const [modifier, _] = modifiers;

        if (document.querySelector('.js-productlist') == null) {
            return;
        }

        el.addEventListener(modifier, () => {
            Cookies.set('keep', JSON.stringify(Object.assign(keptValues, {
                [value]: evaluate(expression),
            })));
        });
    });
});
